import type React from "react";
import { Link } from "react-router";
import { data } from "../../data";
import { useEffect } from "react";

interface ITermsAndConditionProps { }

export const TermsAndConditions: React.FC<ITermsAndConditionProps> = (
    props: ITermsAndConditionProps
) => {
    const { bannerImage, title, breadcrumb, sections } = data.termsAndConditionsContent;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <section id="hero" className="hero section dark-background">
                <img loading="lazy" src={bannerImage} alt="bg-cover-image" style={{ height: "100%" }} />
                <div className="container text-center">
                    <h2 data-aos="fade-up" data-aos-delay="100">{title}</h2>
                    <h6 data-aos="fade-up" data-aos-delay="100" className="mt-4">
                        <Link className="text-light" to="/home">{breadcrumb.homeLabel}</Link>
                        <span className="text-secondary">{" / "}{breadcrumb.currentPage}</span>
                    </h6>
                </div>
            </section>

            <div className="container py-5">
                <div>
                    {sections.map((section, index) => (
                        <div key={index}>
                            <h2 className="text-center">{section.heading}</h2>
                            {section.content && section.content.map((para, idx) => (
                                <p key={idx}>{para}</p>
                            ))}
                            {section.list && (
                                <ul className="text-muted mb-4">
                                    {section.list.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
